module.exports = __webpack_public_path__ + "static/media/IMG_004.db89a3ef.jpg";